import React from 'react';
import ABSTooltip from '../ABSBubble';
import './index.less';
import classNames from 'classnames';
export interface IABSEllipsisProps {
  width?: number;
  details?: any;
  isLink?: boolean;
  children: any;
}

class ABSEllipsis extends React.Component<IABSEllipsisProps> {
  static defaultProps = {
    isLink: false,
  };
  render() { 
    const { children, width, details, isLink } = this.props;
    const newDetails = details ? details : children;
    const clazz = classNames('abs-text-overflow', {'abs-text-overflow-link': isLink });
    const style = width ? { width: width + 'px'} : {};
    return ( 
      <div className={clazz} style={style}>
        <ABSTooltip placement="bottomLeft" arrowPointAtCenter={false} target={children} details={newDetails}/>
      </div>
     );
  }
}
 
export default ABSEllipsis;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/ABSEllipsis/index.tsx